import { useCallback, useEffect, useRef } from 'react';
import { api } from '../lib/api';
import { calculateScrollPercent, getTrackingContext } from '../lib/tracking';

export function usePageTelemetry(_page: string): (eventType: string, registrationId?: string) => void {
  const openedAt = useRef(Date.now());
  const maxScroll = useRef(0);

  const context = useCallback(() => getTrackingContext({
    landingUrl: `${window.location.origin}${window.location.pathname}`,
    timeOnPageSeconds: Math.round((Date.now() - openedAt.current) / 1000),
    scrollPercent: maxScroll.current,
  }), []);

  const track = useCallback((eventType: string, registrationId?: string) => {
    void api.track(eventType, context(), registrationId).catch(() => {
      // Analytics is intentionally best-effort.
    });
  }, [context]);

  useEffect(() => {
    const onScroll = () => {
      maxScroll.current = Math.max(maxScroll.current, calculateScrollPercent());
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    // Dashboard uses this canonical name. The Worker also keeps compatibility
    // with prior `view` events already recorded in production.
    track('page_view');
    return () => {
      window.removeEventListener('scroll', onScroll);
      track('leave');
    };
  }, [track]);

  return track;
}
